RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const View = RivalIQ.channels.views.DismissableView.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        className: 'ads-upsell panel panel-default x-channel-wall callout callout-info text-center',
        template: '#insightsTokenRequestTemplate',
        initialize: function () {
            const me = this;
            me.state = RivalIQ.state.user;
            RivalIQ.channels.views.DismissableView.prototype.initialize.apply(me, arguments);
        },
        serializeData: function () {
            const me = this;
            const presence = me.dashboardModel.curation.presence;
            return _.get(presence.get('sources'), [RivalIQ.enums.sources.INSTAGRAM_INSIGHTS]);
        }
    });

    function isDismissed(widget) {
        return widget.isDismissed({
            state: RivalIQ.state.user
        });
    }

    const Widget = RivalIQ.apps.Dashboard.widgets.TokenRequestWidget.extend({
        filter: function () {
            const me = this;
            return (isDismissed(me) || App.utils.hasInstagramBusinessAccount(me) || me.curation.hasAnyBoostedPosts);
        },

        panelView: View
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_PROMOTED_POSTS_TOKEN_REQUEST, Widget);

    const AdsAccessRevokedWidget = RivalIQ.apps.Dashboard.widgets.TokenRequestWidget.extend({
        filter: function () {
            const me = this;
            return (isDismissed(me) || App.utils.hasInstagramPaidEngagement(me) || !me.curation.hasAnyBoostedPosts);
        },

        panelView: View.extend({
            template: '#insightsAdsAccessRevokedTemplate'
        })
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_PROMOTED_POSTS_ACCESS_REVOKED, AdsAccessRevokedWidget);

    const PromotedPostsLoadingWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        filter: function () {
            const me = this;
            return !RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(me);
        },

        panelView: RivalIQ.views.ItemView.mixin({
            template: '#widgetInstagramInsightsLoadingBoostedTemplate',
            mixins: {
                props: Marionette.Dashboard.mixins.Props
            },
            onRenderLoaded: function () {
                const me = this;
                const curation = me.dashboardModel.curation;

                const channel = RivalIQ.enums.sourceDetails[
                    RivalIQ.enums.sources.INSTAGRAM_INSIGHTS
                ].channel;

                const options = {
                    pollingDelay: 5000,
                    pollingMaxAttempts: 120
                };

                const api = function () {
                    return $.getJSON(`/api/insights/${channel}/presences`);
                };

                const condition = function (presences) {
                    const presenceQuery = {};
                    presenceQuery[`${channel}_presence_id`] = curation.getProp('presenceId');

                    const companyPresence = _.find(presences, presenceQuery);
                    if (!companyPresence) {
                        return false;
                    }

                    return Boolean(_.get(companyPresence, 'last_boosted_post_fetch_at'));
                };

                return RivalIQ.utils.polling.pollUntilCondition(api, condition, options)
                    .done(function () {
                        // TODO: nope. call refresh on curation.router
                        window.location.reload();
                    });
            }
        })
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_PROMOTED_POSTS_LOADING, PromotedPostsLoadingWidget);

});
